import { useState } from 'react';
import axiosPrivate from 'config/axiosPrivate';
import { useTranslation } from 'react-i18next';

export const isTextRevisionNotAllowedError = (error) =>
  error?.response?.status === 406;

export const useTextStatusChange = (onStatusChange, onError, onOptimisticUpdate) => {
  const { t } = useTranslation();
  const [isUpdating, setIsUpdating] = useState(false);

  const statusMap = {
    Brouillon: 'DRAFTED',
    Livré: 'DELIVERED',
    'En révision': 'IN_REVISION',
    Validé: 'VALIDATED',
    'En ligne': 'DEPLOYED',
  };

  const handleStatusChange = async (textId, nextStatus, previousItem) => {
    if (!textId || !nextStatus) return;

    setIsUpdating(true);

     if (onOptimisticUpdate) {
      onOptimisticUpdate(textId, nextStatus);
    }

     const apiStatusType = statusMap[nextStatus] || nextStatus;

    try {
      await axiosPrivate.put(
        `/texts/external/${textId}/update-status?textStatusType=${encodeURIComponent(apiStatusType)}`
      );

      if (onStatusChange) {
        onStatusChange(textId, nextStatus);
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);

      if (onError) {
        onError(error, previousItem);
      } else {
        alert(t('Erreur lors de la mise à jour du statut. Veuillez réessayer.'));
      }
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    handleStatusChange,
    isUpdating,
  };
};

